import { field, form } from "svelte-forms";
import { pattern, required } from "svelte-forms/validators";

const decimalRe = /^\d+(\.\d{1,2})?$/;

// form fields
const vehicleId = field("vehicleId", null, [required()]);
const zendeskTicketId = field("zendeskTicketId", "");
const vehicleNumber = field("vehicleNumber", "", [required()]);
const assetsOwner = field("assetsOwner", "", [required()]);
const carMake = field("carMake", "", [required()]);
const selectedSides = field("selectedSides", [], [required()]); // maps to FinalDamagedSides
const carModel = field("carModel", "", [required()]);
const damageCause = field("damageCause", "", [required()]); // maps to BookingNo
const finalAmount = field("finalAmount", "", [required()]);
const remarks = field("remarks", "", [required()]);
const dateReported = field("dateReported", "", [required()]); // maps to IncidentDateTime
const damageCauseType = field("damageCauseType", "", [required()]); // maps to CollisionType
const noOfRepairDays = field("noOfRepairDays", "", [required()]); // maps to NoOfRepairDays
const caseType = field("caseType", "", [required()]); // maps to CaseType
const claimType = field("claimType", "", [required()]); // maps to ClaimType
const liabilityType = field("liabilityType", "", [required()]); // maps to LiabilityType
const actualRepairCost = field("actualRepairCost", "", [
	required(),
	pattern(decimalRe),
]); // maps to ActualRepairCost
const linkToCases = field("linkToCases", []); // maps to LinkToCase
const attribution = field("attribution", "Unknown"); // maps to AttributedTo
const staffName = field("staffName", "", [required()]); // maps to staffName
const staffContact = field("staffContact", "", [required()]); // maps to StaffContactNo
const thirdPartyName = field("thirdPartyName", "", [required()]); // maps to ThirdPartyName
const thirdPartyContact = field("thirdPartyContact", "", [required()]); // maps to ThirdPartyContactNo
const accidentGIAReportNo = field("accidentGIAReportNo", ""); // maps to AccidentGIAReportNo
const workshopInvoiceFiles = field("workshopInvoiceFiles", []); // file arrays
const additionalPhotoFiles = field("additionalPhotoFiles", []);
const additionalMediaFiles = field("additionalMediaFiles", []);
const incidentDateTime = field("incidentDateTime", "", [required()]); // maps to IncidentDateTime
const vqp = field("vqp", null); // maps to VQP
const l1Remarks = field("l1Remarks", ""); // maps to L1Remarks
const tnsRemarks = field("tnsRemarks", ""); // maps to TNSRemarks

function resetFields() {
	vehicleId.reset();
	vehicleNumber.reset();
	assetsOwner.reset();
	carMake.reset();
	carModel.reset();
	selectedSides.reset();
	damageCause.reset();
	finalAmount.reset();
	remarks.reset();
	dateReported.reset();
	damageCauseType.reset();
	noOfRepairDays.reset();
	caseType.reset();
	claimType.reset();
	liabilityType.reset();
	actualRepairCost.reset();
	attribution.reset();
	staffName.reset();
	staffContact.reset();
	thirdPartyName.reset();
	thirdPartyContact.reset();
	accidentGIAReportNo.reset();
	workshopInvoiceFiles.reset();
	additionalPhotoFiles.reset();
	additionalMediaFiles.reset();
	linkToCases.clear();
	zendeskTicketId.reset();
	incidentDateTime.reset();
	caseCreationForm.reset();
	vqp.reset();
	l1Remarks.reset();
	tnsRemarks.reset();
}

const caseCreationForm = form(
	vehicleId,
	vehicleNumber,
	assetsOwner,
	carMake,
	carModel,
	selectedSides,
	damageCause,
	finalAmount,
	remarks,
	dateReported,
	damageCauseType,
	noOfRepairDays,
	caseType,
	claimType,
	liabilityType,
	actualRepairCost,
	attribution,
	staffName,
	staffContact,
	thirdPartyName,
	thirdPartyContact,
	accidentGIAReportNo,
	workshopInvoiceFiles,
	additionalPhotoFiles,
	additionalMediaFiles,
	linkToCases,
	zendeskTicketId,
	incidentDateTime,
	vqp,
	l1Remarks,
	tnsRemarks
);

export {
	vehicleId,
	zendeskTicketId,
	incidentDateTime,
	vehicleNumber,
	assetsOwner,
	carMake,
	selectedSides,
	carModel,
	damageCause,
	finalAmount,
	remarks,
	dateReported,
	damageCauseType,
	noOfRepairDays,
	caseType,
	claimType,
	liabilityType,
	actualRepairCost,
	linkToCases,
	attribution,
	staffName,
	staffContact,
	thirdPartyName,
	thirdPartyContact,
	accidentGIAReportNo,
	workshopInvoiceFiles,
	additionalPhotoFiles,
	additionalMediaFiles,
	caseCreationForm,
	resetFields,
	vqp,
	l1Remarks,
	tnsRemarks,
};
